(function () {
  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function bytesToMb(bytes) {
    return Math.round((bytes / (1024 * 1024)) * 10) / 10;
  }

  function focusFirstField(step) {
    if (!step) return;
    var target = step.querySelector("input, textarea, button, select");
    if (target) target.focus({ preventScroll: true });
  }

  ready(function () {
    var root = document.querySelector("[data-bespoke-root]");
    if (!root) return;

    var modal = root.querySelector("[data-bespoke-modal]");
    var dialog = root.querySelector(".ac-bespoke__modal-dialog");
    var form = root.querySelector("[data-bespoke-wizard]");
    if (!modal || !dialog || !form) return;

    var endpoint = (form.dataset.endpoint || "").replace(/\/$/, "");
    var variantId = form.dataset.variantId || "";
    var maxFileBytes = Number(form.dataset.maxFileBytes || 0);
    var steps = Array.from(form.querySelectorAll("[data-bespoke-step]"));
    var stepDots = Array.from(root.querySelectorAll("[data-bespoke-step-dot]"));
    var nextButtons = Array.from(form.querySelectorAll("[data-bespoke-next]"));
    var prevButtons = Array.from(form.querySelectorAll("[data-bespoke-prev]"));
    var openButtons = Array.from(root.querySelectorAll("[data-bespoke-open]"));
    var closeButtons = Array.from(root.querySelectorAll("[data-bespoke-close]"));
    var submitButton = form.querySelector("[data-bespoke-submit]");
    var statusEl = form.querySelector("[data-bespoke-status]");
    var fileInput = form.querySelector('input[name="badge_image"]');
    var fileName = form.querySelector("[data-bespoke-file-name]");
    var summary = form.querySelector("[data-bespoke-summary]");
    var submitDefaultText = submitButton ? submitButton.textContent : "";
    var currentStep = 0;

    function setStatus(message, type) {
      if (!statusEl) return;
      statusEl.textContent = message || "";
      statusEl.dataset.state = type || "";
      statusEl.hidden = !message;
    }

    function selectedGarments() {
      return Array.from(form.querySelectorAll('input[name="garment_choices"]:checked')).map(function (input) {
        return input.value;
      });
    }

    function renderSummary() {
      if (!summary) return;

      var name = form.elements.customer_name ? form.elements.customer_name.value.trim() : "";
      var email = form.elements.customer_email ? form.elements.customer_email.value.trim() : "";
      var phone = form.elements.contact_phone ? form.elements.contact_phone.value.trim() : "";
      var whatsapp = form.elements.whatsapp ? form.elements.whatsapp.value.trim() : "";
      var message = form.elements.request_message ? form.elements.request_message.value.trim() : "";
      var garments = selectedGarments();
      var file = fileInput && fileInput.files ? fileInput.files[0] : null;

      summary.innerHTML = [
        "<li><strong>Badge upload:</strong> " + (file ? file.name : "Not selected") + "</li>",
        "<li><strong>Contact:</strong> " + (name || "Not provided") + " · " + (email || "No email") + "</li>",
        "<li><strong>Phone:</strong> " + (phone || "Not provided") + "</li>",
        "<li><strong>WhatsApp:</strong> " + (whatsapp || "Not provided") + "</li>",
        "<li><strong>Garments to quote:</strong> " + (garments.length ? garments.join(", ") : "Digitising service only") + "</li>",
        "<li><strong>Notes:</strong> " + (message || "No extra instructions added") + "</li>"
      ].join("");
    }

    function lockPage(isLocked) {
      document.documentElement.classList.toggle("ac-bespoke-modal-open", isLocked);
      document.body.classList.toggle("ac-bespoke-modal-open", isLocked);
    }

    function openModal() {
      modal.hidden = false;
      modal.setAttribute("aria-hidden", "false");
      lockPage(true);
      dialog.scrollTop = 0;
      showStep(currentStep);
    }

    function closeModal() {
      modal.hidden = true;
      modal.setAttribute("aria-hidden", "true");
      lockPage(false);
      setStatus("", "");
    }

    function showStep(index) {
      currentStep = index;

      steps.forEach(function (step, stepIndex) {
        var active = stepIndex === index;
        step.hidden = !active;
        step.classList.toggle("is-active", active);
      });

      stepDots.forEach(function (dot, dotIndex) {
        dot.classList.toggle("is-active", dotIndex === index);
      });

      if (index === steps.length - 1) {
        renderSummary();
      }

      setStatus("", "");
      dialog.scrollTop = 0;
      window.requestAnimationFrame(function () {
        focusFirstField(steps[index]);
      });
    }

    function validateFile() {
      if (!fileInput || !fileInput.files || !fileInput.files[0]) {
        setStatus("Please upload a badge image before continuing.", "error");
        return false;
      }

      var file = fileInput.files[0];
      var allowed = ["image/jpeg", "image/png", "image/webp"];
      if (allowed.indexOf(file.type) === -1) {
        setStatus("Only JPG, PNG, and WEBP image files are allowed.", "error");
        return false;
      }

      if (maxFileBytes > 0 && file.size > maxFileBytes) {
        setStatus("Badge artwork must be " + bytesToMb(maxFileBytes) + "MB or smaller.", "error");
        return false;
      }

      return true;
    }

    function validateStep(index) {
      setStatus("", "");

      if (index === 0) {
        if (!validateFile()) return false;

        var rights = form.elements.confirms_rights;
        var policy = form.elements.confirms_policy;
        if (!rights || !rights.checked || !policy || !policy.checked) {
          setStatus("Please confirm the artwork rights and upload policy before continuing.", "error");
          return false;
        }
      }

      if (index === 1) {
        var name = form.elements.customer_name ? form.elements.customer_name.value.trim() : "";
        var email = form.elements.customer_email ? form.elements.customer_email.value.trim() : "";

        if (!name) {
          setStatus("Please enter your full name.", "error");
          return false;
        }

        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          setStatus("Please enter a valid email address.", "error");
          return false;
        }
      }

      return true;
    }

    openButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        openModal();
      });
    });

    closeButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        closeModal();
      });
    });

    modal.addEventListener("click", function (event) {
      if (event.target === modal || event.target.hasAttribute("data-bespoke-close")) {
        closeModal();
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && !modal.hidden) {
        closeModal();
      }
    });

    nextButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        if (!validateStep(currentStep)) return;
        showStep(Math.min(currentStep + 1, steps.length - 1));
      });
    });

    prevButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        showStep(Math.max(currentStep - 1, 0));
      });
    });

    if (fileInput) {
      fileInput.addEventListener("change", function () {
        var file = fileInput.files && fileInput.files[0];
        if (fileName) {
          fileName.textContent = file ? file.name + " · " + bytesToMb(file.size) + "MB" : "No badge uploaded yet";
        }
        if (file) validateFile();
      });
    }

    form.addEventListener("submit", async function (event) {
      event.preventDefault();

      if (!endpoint) {
        setStatus("The bespoke embroidery service endpoint is not configured yet.", "error");
        return;
      }

      if (!variantId) {
        setStatus("The bespoke service product is not linked yet. Add the service variant ID in the theme section settings.", "error");
        return;
      }

      if (!validateStep(currentStep)) return;

      var payload = new FormData(form);
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = "Preparing your order…";
      }
      setStatus("Uploading badge artwork and creating your paid digitising request…", "info");

      try {
        var response = await fetch(endpoint + "/api/bespoke/draft", {
          method: "POST",
          body: payload
        });

        var data;
        try {
          data = await response.json();
        } catch (_error) {
          data = {
            ok: false,
            error: response.ok
              ? "The bespoke service returned an unreadable response."
              : "The bespoke service could not be reached or returned an invalid response."
          };
        }

        if (!response.ok || !data.ok) {
          throw new Error(data.error || "Could not prepare the bespoke embroidery request.");
        }

        var cartResponse = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest"
          },
          body: JSON.stringify({
            id: Number(variantId),
            quantity: 1,
            properties: data.cartLineProperties || {
              "_vip_bespoke_draft_token": data.draftToken
            }
          })
        });

        if (!cartResponse.ok) {
          throw new Error("The service fee could not be added to cart.");
        }

        setStatus("Success. The digitising service has been added to your cart.", "success");
        window.location.href = "/cart";
      } catch (error) {
        setStatus(error.message || "Something went wrong while preparing your bespoke request.", "error");
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = submitDefaultText;
        }
      }
    });

    showStep(0);
  });
})();
